module.exports = __webpack_public_path__ + "static/media/ires.b537c526.png";